export function DashboardInstantOffline() {
  return (
    <div className='shadow-full rounded-xl p-4 lg:w-full w-11/12 h-fit mt-10 flex flex-col bg-[#bceda6] font-mont'>
      <div className='w-full max-sm:scale-90 flex flex-col items-center'>
        <div className='flex flex-col items-center gap-4 mt-5'>
          <p className='text-3xl font-bold'>Hang Tight!</p>
          <p className='text-lg text-center text-red-600 font-medium'>Our instant calculator is taking a quick break due to IRS maintenance. Please check back later, thank you!</p>
        </div>
      </div>
    </div>
  )
}